module.exports = __webpack_public_path__ + "static/media/pause.23093af5.svg";